import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="privacy-page">
      <Header />
      <main className="flex-1">
        <section className="bg-primary text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 md:py-14">
            <p className="text-accent text-sm font-semibold tracking-wider uppercase mb-3">Legal</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold">Privacy Policy</h1>
            <p className="text-white/70 mt-3 text-sm">Last updated: January 2026</p>
          </div>
        </section>

        <article className="max-w-4xl mx-auto px-4 sm:px-6 py-10 md:py-14 prose prose-slate max-w-none">
          <p className="text-ink/80 leading-relaxed">
            We respect your privacy and are committed to protecting your personal information. This policy explains what we collect, how we use it, and the choices you have regarding your data on The Pataudi.
          </p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">1. Information we collect</h2>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5">
            <li>Name, email address and phone number.</li>
            <li>Listing details (if you are a seller) — title, description, photos, category, price and contact you choose to share.</li>
            <li>Payment references (Razorpay order id / payment id) for the plans you purchase. Card details are never stored on our servers.</li>
            <li>Usage data — pages visited, listings unlocked, basic device / browser info, IP address for security and fraud prevention.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">2. How we use your information</h2>
          <ul className="list-disc pl-6 text-ink/80 space-y-1.5">
            <li>To create and manage your account.</li>
            <li>To display listings and connect buyers with sellers.</li>
            <li>To process payments for buyer credits, seller subscription plans and the Verified Seller badge.</li>
            <li>To send transactional emails such as OTPs, password resets and payment receipts.</li>
            <li>To improve platform functionality, fix bugs and build new features.</li>
          </ul>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">3. Data protection</h2>
          <p className="text-ink/80 leading-relaxed">We implement standard security measures — passwords are stored as one-way bcrypt hashes, sessions use HTTP-only cookies, and payments run through Razorpay’s PCI-DSS compliant flow. Please note that no online system can guarantee 100% security.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">4. Third-party sharing</h2>
          <p className="text-ink/80 leading-relaxed">We do <strong>not</strong> sell your personal data. Information is only shared when needed to run the platform (for example, with Razorpay for payments and with our email delivery provider for OTPs) or when required by law or a valid legal order.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">5. User control</h2>
          <p className="text-ink/80 leading-relaxed">You can update or delete your account information any time from your dashboard. Full account deletion can be requested by writing to <a href="mailto:sales@thepataudi.com" className="text-primary underline">sales@thepataudi.com</a>.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">6. Cookies</h2>
          <p className="text-ink/80 leading-relaxed">We use a small number of cookies — primarily to keep you logged in and to remember your session. No third-party advertising trackers are used.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">7. Children</h2>
          <p className="text-ink/80 leading-relaxed">The Pataudi is not intended for users under 18. If you believe a minor has created an account, please contact us and we will remove it.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">8. Changes</h2>
          <p className="text-ink/80 leading-relaxed">We may update this policy as the platform evolves. Material changes will be announced with a new “Last updated” date.</p>

          <h2 className="font-display text-2xl font-bold text-ink mt-8 mb-3">9. Contact</h2>
          <p className="text-ink/80 leading-relaxed">Questions? Reach us at <a href="mailto:sales@thepataudi.com" className="text-primary underline">sales@thepataudi.com</a>, call <a href="tel:9467458749" className="text-primary underline">+91 9467458749</a>, or message us on <a href="https://wa.me/919467458749" target="_blank" rel="noopener noreferrer" className="text-primary underline">WhatsApp</a>.</p>
        </article>
      </main>
      <Footer />
    </div>
  );
}
